import React, { useState, useEffect } from 'react';
import {MultiSelect} from 'react-multi-select-component';
import Cookie from 'js-cookie';
import axios from 'axios';
import { Config } from '../config/config';

const Search: React.FC = (props) => {
  let stores = [];
  const config = JSON.parse(Config);

  stores = props.allStores.sort((a, b) => (a.storeName > b.storeName ? 1 : -1));

  let storesData = [];
  let NotCheckedStoresData = [];
  stores &&
    stores.map((val, index) => {
      if (val.currentStore == 1) {
        storesData.push({
          label: val.storeName,
          value: val.storeId,
        });
      }

      NotCheckedStoresData.push({
        label: val.storeName,
        value: val.storeId,
      });
    });

  const [selected, setSelected] = useState(props.selectedData);

  useEffect(() => {
    if (props.cityChanged) {
      setSelected([]);
    }
  }, [props.cityChanged]);
  const selection = (e) => {
    setSelected(e);
  };

  return (
    <div data-tip data-for='registerTip'>
      <MultiSelect
        className='multiSelectAll'
        options={NotCheckedStoresData}
        value={selected}
        onChange={selection}
        labelledBy={
          props.selectedData ? props.selectedData.label : stores.storeName
        }
        overrideStrings={{
          selectSomeItems: 'Search for stores',
          allItemsAreSelected: 'All stores are selected.',
          selectAll: 'Select All',
          search: 'Search',
        }}
      />
      {props.name === 'incidents'
        ? localStorage.setItem(
            'incidentStores',
            JSON.stringify({ type: props.name, data: JSON.stringify(selected) })
          )
        : localStorage.setItem(
            'evacuationStores',
            JSON.stringify({ type: props.name, data: JSON.stringify(selected) })
          )}
    </div>
  );
};

export default Search;
